/**
 * Temporary placeholder component to prevent console errors, will be removed later
 */
export function Placeholder(): JSX.Element {
    return <></>;
}
